const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('section.module-tabs').forEach(section => {
        const nav = section.querySelector<HTMLElement>('.tabs-nav')
        const allDetails = Array.from(section.querySelectorAll<HTMLDetailsElement>('.tab-section'))

        if (!nav || !allDetails.length) return

        // Assign IDs and populate nav with one button per tab
        const group = nav.dataset.group ?? 'tab'
        allDetails.forEach((det, i) => {
            if (!det.id) det.id = `${group}-${i}`

            const titleEl = det.querySelector<HTMLElement>('.tab-title')
            const title = titleEl?.textContent?.trim() ?? ''

            const btn = document.createElement('button')
            btn.type = 'button'
            btn.className = 'tabs-nav-link'
            btn.textContent = title
            btn.dataset.target = det.id
            if (det.open) btn.classList.add('is-active')

            nav.appendChild(btn)
        })

        // Nav click → open the target details
        // (native name-grouped details closes the others automatically)
        nav.addEventListener('click', e => {
            const btn = (e.target as HTMLElement).closest<HTMLElement>('.tabs-nav-link')
            if (!btn) return
            const target = document.getElementById(btn.dataset.target!)
            if (target) (target as HTMLDetailsElement).open = true
        })

        // Details toggle → sync active class on the matching nav button
        allDetails.forEach(det => {
            det.addEventListener('toggle', () => {
                const btn = nav.querySelector<HTMLElement>(`.tabs-nav-link[data-target="${det.id}"]`)
                if (btn) btn.classList.toggle('is-active', det.open)
            })
        })

        // Keyboard navigation between nav buttons (Tab key only)
        nav.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key !== 'Tab') return

            const links = Array.from(nav.querySelectorAll<HTMLElement>('.tabs-nav-link'))
            const idx = links.indexOf(document.activeElement as HTMLElement)
            if (idx === -1) return

            if (!e.shiftKey && idx < links.length - 1) {
                // Tab → next nav button
                e.preventDefault()
                links[idx + 1].focus()
            } else if (!e.shiftKey && idx === links.length - 1) {
                // Tab on last button → move into open tab content
                const openContent = section.querySelector<HTMLElement>('.tab-section[open] .tab-content')
                const first = openContent?.querySelector<HTMLElement>(FOCUSABLE) ?? null
                if (first) {
                    e.preventDefault()
                    first.focus()
                }
            } else if (e.shiftKey && idx > 0) {
                // Shift+Tab → previous nav button
                e.preventDefault()
                links[idx - 1].focus()
            }
            // Shift+Tab on first → let focus leave the nav naturally
        })
    })
})